import React from 'react';
import { Helmet } from 'react-helmet';

import { Footer, Landing, Contacts } from '../../components';
import Navigation from '../../components/Navigation/Navigation';
import RecognitionBar from '../../components/RecognitionBar/RecognitionBar';
import ImpactMetrics from '../../components/ImpactMetrics/ImpactMetrics';
import Honors from '../../components/Honors/Honors';
import CaseStudies from '../../components/CaseStudies/CaseStudies';
import Leadership from '../../components/Leadership/Leadership';
import Experience from '../../components/Experience/Experience';
import Endorsements from '../../components/Endorsements/Endorsements';
import Education from '../../components/Education/Education';
import Achievements from '../../components/Achievements/Achievements';
import Press from '../../components/Press/Press';
import Writing from '../../components/Writing/Writing';
import About from '../../components/About/About';
import { headerData } from '../../data/headerData';

function Main() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} | Director of Technology</title>
                <meta
                    name="description"
                    content="Ravi Teja Alchuri, Director of Technology and IEEE Senior Member. Engineering leader architecting federally-regulated, AI-driven fleet platforms serving 100,000+ commercial vehicles."
                />
            </Helmet>

            <Navigation />

            {/* 1. Hero / Overview */}
            <Landing />

            {/* 2. Recognition marquee */}
            <RecognitionBar />

            {/* 3. Impact at scale */}
            <ImpactMetrics />

            {/* 4. Honors & Distinctions */}
            <Honors />

            {/* 5. Selected Work / Original Contributions */}
            <CaseStudies />

            {/* 6. Leadership & Scope */}
            <Leadership />

            {/* 7. Experience Timeline */}
            <Experience />

            {/* 8. Endorsements from leaders */}
            <Endorsements />

            {/* 9. In the Press */}
            <Press />

            {/* 9. Technical Writing */}
            <Writing />

            {/* 10. Education */}
            <Education />

            {/* 11. Certifications & Credentials */}
            <Achievements />

            {/* 12. About / Personal */}
            <About />

            {/* 13. Contact */}
            <Contacts />

            <Footer />
        </div>
    );
}

export default Main;
